import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage, isSettingsTab } from '@/page/SettingsPage';

export const Route = createFileRoute('/_app/settings/$tab')({
  params: { parse: ({ tab }) => ({ tab: isSettingsTab(tab) ? tab : 'profile' }) },
  component: SettingsTabRoute,
});

function SettingsTabRoute() {
  const { tab } = Route.useParams();
  return <SettingsPage tab={tab} />;
}
